import React, {useEffect, useState} from 'react'
import {useClubChargeContext} from "./store/useClubChargeContext"
import DisplayResult from "../../util/DisplayResult"
import {Button, Card, Descriptions, Form, message, Modal, PageHeader, Result, Skeleton, Space} from "antd"
import {DeleteFilled, EditFilled, ExclamationCircleOutlined, PlusCircleOutlined} from "@ant-design/icons"
import {ClubChargeForm} from "./component/ClubChargeForm"

export const ClubChargeLayout = () => {
    const state = useClubChargeContext()

    const [isShowEditForm, setIsShowEditForm] = useState(false)
    const [form] = Form.useForm()
    const {confirm} = Modal

    const showEditForm = (item) => {
        state.getChargeTableList(item.id)
        form.setFieldsValue({
            id: item.id,
            amount: (item.amount / 100).toFixed(2),
            targetWalletId: item.target_wallet,
            giftAmount: (item.gift_amount / 100).toFixed(2),
            giftWalletId: item.gift_wallet,
            giftLevelId: item.gift_level,
            isShowAllTable: item.is_show_all_table === "1",
        })
        setIsShowEditForm(true)
    }

    const showAddForm = () => {
        form.setFieldsValue({
            isShowAllTable: true
        })
        setIsShowEditForm(true)
    }


    const onHideForm = () => {
        setIsShowEditForm(false)
        form.resetFields()
    }

    const onDeleteCharge = (item, index) => {
        confirm({
                title: `删除套餐`,
                icon: <ExclamationCircleOutlined/>,
                content: `确定删除套餐${index + 1}吗`,
                onOk() {
                    return state.deleteCharge(item.id)
                },
            }
        )
    }

    const addOrUpdateCharge = async (isUpdate) => {
        const formData = form.getFieldsValue()

        if (formData.targetWalletId===undefined){
            message.error("请选择充值钱包")
            return
        }

        if ((formData.giftLevelId === "0" || formData.giftLevelId === undefined) && (formData.giftWalletId === "0"||formData.giftWalletId===undefined)) {
            message.error("赠送钱包和获得会员级别不为同时都是无")
            return
        }

        if (!formData.isShowAllTable && formData.tableIds.length === 0) {
            message.error("请选择桌台")
            return
        }

        let data
        if (isUpdate) {
            data = {
                amount: (formData.amount * 100).toFixed(2),
                clubId: sessionStorage.getItem('club_id'),
                gift_amount: (formData.giftAmount * 100).toFixed(2),
                gift_level: formData.giftLevelId === "0" ? "" : formData.giftLevelId,
                gift_wallet: formData.giftWalletId === "0" ? "" : formData.giftWalletId,
                id: formData.id,
                is_show_all_table: formData.isShowAllTable,
                table_ids: formData.tableIds ? formData.tableIds : [],
                target_wallet: formData.targetWalletId
            }
        } else {
            data = {
                amount: (formData.amount * 100).toFixed(2),
                clubId: sessionStorage.getItem('club_id'),
                gift_amount: (formData.giftAmount * 100).toFixed(2),
                gift_level: formData.giftLevelId === "0" ? "" : formData.giftLevelId,
                gift_wallet: formData.giftWalletId === "0" ? "" : formData.giftWalletId,
                is_show_all_table: formData.isShowAllTable,
                table_ids: formData.tableIds ? formData.tableIds : [],
                target_wallet: formData.targetWalletId
            }
        }

        await state.addOrUpdateCharge(data)
    }


    useEffect(() => {
        if (state.addOrUpdateChargeState.isSuccess()) {
            message.success("修改成功")
            setIsShowEditForm(false)
            form.resetFields()
            state.getChargeList()
            return
        }

        if (state.addOrUpdateChargeState.isError()) {
            message.error(`修改失败：${state.addOrUpdateChargeState.getErrorMessage()}`)
        }

    }, [state.addOrUpdateChargeState])

    useEffect(() => {
        if (state.deleteChargeState.isSuccess()) {
            message.success("删除成功")
            state.getChargeList()
            return
        }

        if (state.deleteChargeState.isError()) {
            message.error(`删除失败：${state.deleteChargeState.getErrorMessage()}`)
        }
    }, [state.deleteChargeState])

    return <div>
        <DisplayResult
            state={state.getChargeState}
            onLoading={() => (<Skeleton/>)}
            onEmpty={() => {
                const paymentList = state.getPaymentState.getSuccessData().paymentTypeList.filter(item => (item.id >= 1000))
                const clubLevelList = state.getLevelState.getSuccessData().club
                return <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>

                    <Result title={"暂无可用充送列表"}
                            subTitle={<Button type={"primary"} onClick={showAddForm}>点击添加</Button>}/>
                    <ClubChargeForm form={form} isOpen={isShowEditForm} walletList={paymentList}
                                    levelList={clubLevelList} onCancel={onHideForm} onOk={addOrUpdateCharge}/>
                </div>
            }}
            onError={(value) => (<Result title={"获取充送列表失败"} subTitle={value} status={"error"}/>)}
            onSuccess={(value) => {
                const paymentList = state.getPaymentState.getSuccessData().paymentTypeList.filter(item => (item.id >= 1000))
                const clubLevelList = state.getLevelState.getSuccessData().club
                return <div>
                    <PageHeader title={(
                        <Space>
                            <div style={{marginRight: 20}}>充值赠送及优惠设置</div>
                            <Button type={"primary"} icon={<PlusCircleOutlined/>} onClick={showAddForm}>添加一个阶梯</Button>
                        </Space>
                    )}/>
                    <Card bordered={false}>
                        <div style={{display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 20}}>
                            {value.coupon_balance.map((item, index) => {

                                    const targetWallet = paymentList.find((payment) => (payment.id === item.target_wallet))
                                    const giftWallet = paymentList.find((payment) => (payment.id === item.gift_wallet))
                                    const giftLevel = clubLevelList.find((level) => (level.id === item.gift_level))

                                    return <Card
                                        key={index}
                                        title={(
                                            <div style={{display: "flex", justifyContent: "left"}}>{`套餐${index + 1}`}</div>
                                        )}
                                        extra={(
                                            <div style={{fontSize: "16px", fontWeight: "bold"}}>
                                                {`充${Number.isInteger(item.amount / 100) ? (item.amount / 100) : (item.amount / 100).toFixed(2)}送${Number.isInteger(item.gift_amount / 100) ? (item.gift_amount / 100) : (item.gift_amount / 100).toFixed(2)}`}
                                            </div>
                                        )}
                                        actions={[
                                            <Button type={"text"} danger={true}
                                                    icon={<DeleteFilled/>}
                                                    onClick={() => onDeleteCharge(item, index)}>删除</Button>,
                                            <Button type={"text"} style={{color: "green"}} icon={<EditFilled/>}
                                                    onClick={() => showEditForm(item)}>编辑</Button>
                                        ]}
                                    >
                                        <div>
                                            <Descriptions column={1}>
                                                <Descriptions.Item
                                                    label="充送到">{targetWallet ? targetWallet.name : "无"}</Descriptions.Item>
                                                <Descriptions.Item
                                                    label="赠送到">{giftWallet ? giftWallet.name : "无"}</Descriptions.Item>
                                                <Descriptions.Item
                                                    label="获得会员级别">{giftLevel ? `${giftLevel.name}-${giftLevel.discount_name}` : "无"}</Descriptions.Item>
                                            </Descriptions>
                                        </div>
                                    </Card>
                                }
                            )}
                        </div>
                    </Card>

                    <ClubChargeForm form={form} isOpen={isShowEditForm} walletList={paymentList}
                                    levelList={clubLevelList} onCancel={onHideForm} onOk={addOrUpdateCharge}/>

                </div>
            }}
        />


    </div>
}


// WEBPACK FOOTER //
// ./src/containers/ClubCharge/layout.js